import React from 'react'

import * as styles from './ImageSection.module.scss'

export const ImageSection = ({ source, alt }) => (
  <div className={styles.container}>
    <img src={source} className={styles.image} alt={alt} />
  </div>
)